import { useState } from 'react';
import { operateur } from '../api.js';

/**
 * Écran d'identification de l'opérateur.
 *
 * INTERMÉDIAIRE, à remplacer par le SSO Etna. Sans lui, l'application ne peut rien
 * faire : le serveur exige une identité sur chaque requête et renvoie 401 sinon.
 *
 * Ce n'est pas une authentification — n'importe qui peut saisir n'importe quel nom.
 * Son rôle est que le journal d'événements, qui fait partie du faisceau de preuves,
 * porte le nom d'une personne réelle plutôt qu'un blanc. Pour le test, l'application
 * reste sur le réseau interne ; en production, le SSO fournira une identité vérifiée.
 */
export function Identification({ onIdentifie }) {
  const [valeur, setValeur] = useState('');
  const valide = valeur.trim().length >= 2;

  const valider = () => {
    if (!valide) return;
    operateur.definir(valeur);
    onIdentifie();
  };

  return (
    <>
      <header className="appli">
        <h1>Fiche de réception travaux</h1>
        <div className="ref">Etna France</div>
      </header>
      <main>
        <div className="carte">
          <h2>Identification</h2>
          <p className="sous-titre">
            Indiquez votre nom ou votre matricule. Il figurera sur le journal de chaque
            fiche que vous traiterez.
          </p>
          <label className="champ">
            <span className="intitule">Nom ou matricule</span>
            <input
              type="text"
              value={valeur}
              autoCapitalize="words"
              onChange={(ev) => setValeur(ev.target.value)}
              onKeyDown={(ev) => { if (ev.key === 'Enter') valider(); }}
            />
          </label>
        </div>
      </main>
      <nav className="barre">
        <button type="button" className="primaire" onClick={valider} disabled={!valide}>
          Continuer
        </button>
      </nav>
    </>
  );
}
